// extracted by mini-css-extract-plugin
module.exports =  {"divider":"Divider-module__divider___TSzOv"};